import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import * as S from './style';

const SignUpComplete = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<S.Container>
			<S.IconWrap aria-hidden>✓</S.IconWrap>
			<S.Title>{t('signup.complete.title')}</S.Title>
			<S.Description>{t('signup.complete.description')}</S.Description>
			<S.HomeButton type="button" onClick={() => navigate('/auth/login')}>
				{t('common.actions.goToLogin')}
			</S.HomeButton>
		</S.Container>
	);
};

export default SignUpComplete;
